import classnames from 'classnames'
import * as React from 'react'

export enum KeyStatVariant {
  Default,
  Positive,
  Negative,
}

type KeyStatProps = {
  datapoint: React.ReactNode
  label: React.ReactNode
  subdatapoint?: React.ReactNode
  sublabel?: React.ReactNode
  variant?: KeyStatVariant
}

export function KeyStat({ datapoint, label, subdatapoint, sublabel, variant = KeyStatVariant.Default }: KeyStatProps) {
  return (
    <div className="flex flex-col">
      <span className="text-2xs leading-4 text-muted">{label}</span>
      <span
        className={classnames('-my-0.5 text-xl font-bold', {
          'text-default': variant === KeyStatVariant.Default,
          'text-positive': variant === KeyStatVariant.Positive,
          'text-negative': variant === KeyStatVariant.Negative,
        })}
      >
        {datapoint}
        {subdatapoint && (
          <span
            className={classnames('pl-1 text-2xs font-medium', {
              'text-muted': variant === KeyStatVariant.Default,
            })}
          >
            {subdatapoint}
          </span>
        )}
      </span>
      {sublabel && <span className="text-3xs leading-3 text-muted-2">{sublabel}</span>}
    </div>
  )
}
